var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"--admin"},[_vm._v(" -- Admin Message -- ")])
}
var staticRenderFns = []

export { render, staticRenderFns }